export const centerBox = {
    display: "flex",
    justifyContent: "center",
};

export const faqTitle = {
    width: "100%",
};
